import percentage from 'Shared/functions/percentage'
import Loading from 'Shared/components/Loading'
import StepStatBox from './StepStatBox'
import DonateStepStats from './DonateStepStats'
import './FlowStats.scoped.scss'

const STEP_CONFIG = {
  donate: {
    component: 'donate'
  },
  share: {
    label: 'Shares',
    getValue: (step) => step.completed || 0
  },
  survey: {
    label: 'Surveys completed',
    getValue: (step) => step.completed || 0
  },
  email_to_target: {
    label: 'Emails sent',
    getValue: (step, stats) => {
      const emailStep = stats?.steps?.find(s => s.kind === 'email_to_target')
      return emailStep ? emailStep.emailsSent || 0 : 0
    }
  }
}

function FlowStats({ }) {
  const { stats, section } = useSel((s) => s.flow)

  const allowedStepTypes = Object.keys(STEP_CONFIG)
  const filteredSteps = stats?.steps?.filter(step => allowedStepTypes.includes(step.kind)) || []

  const ballotStats = [
    { label: 'Eligible ballot audience', value: stats?.ballotAudience || 0 },
    { label: 'Started ballot', value: stats?.flowsStarted || 0 },
    { label: 'Completed ballot', value: stats?.flowsCompleted || 0 },
    { label: 'Audience completion rate', value: `${percentage(stats?.flowsCompleted || 0, stats?.ballotAudience || 0)}%` },
    { label: 'Remaining audience to start', value: (stats?.ballotAudience || 0) - (stats?.flowsStarted || 0) },
    { label: 'Remaining audience to complete', value: (stats?.ballotAudience || 0) - (stats?.flowsCompleted || 0) }
  ]

  const renderStepStats = () => {
    return filteredSteps.map((step, index) => {
      const config = STEP_CONFIG[step.kind]
      if (!config) return null

      const isFirst = index === 0

      if (config.component === 'donate') {
        return <DonateStepStats key={step.kind} stats={stats} isFirst={isFirst} />
      }

      return (
        <StepStatBox
          key={step.kind}
          value={config.getValue(step, stats)}
          label={config.label}
          isFirst={isFirst}
        />
      )
    })
  }

  if (!section) {
    return <Loading />
  }

  return (
    <div>
      {section === 'ballots' && (<div className="primary-actions">
        {ballotStats.map(stat => (
          <div key={stat.label} className="primary-action">
            <p className='number'>{stat.value}</p>
            <p className='label'>{stat.label}</p>
          </div>
        ))}
      </div>)}

      {section === 'pages' && (<>
        {filteredSteps.length > 0 && (
          <div className='primary-actions'>
            {renderStepStats()}
          </div>
        )}

        <p className="margin-bottom half bold">Page conversion</p>
        <div className='primary-actions'>
          <div className="primary-action">
            <p className='number'>{stats?.flowsStarted || 0}</p>
            <p className='label'>Started page</p>
          </div>
          <div className="primary-action">
            <p className='number'>{stats?.flowsCompleted || 0}</p>
            <p className='label'>Completed page*</p>
          </div>
          <div className="primary-action">
            <p className='number'>
              {`${percentage(stats?.flowsCompleted || 0, stats?.flowsStarted || 0)}%`}
            </p>
            <p className='label'>Completion rate*</p>
          </div>
        </div>
        <p className='small smaller dark-grey no-margin-bottom'>Completions are counted as taking every action on this page.</p>
      </>)}
    </div>
  )
}

export default FlowStats
